import { useEffect, useState } from 'react'

import Api from 'services/api'

import { PremiumAdoption } from 'types/PremiumAdoption'

const usePremiumAdoption = () => {
  const [premiumDealers, setPremiumDealers] = useState<Array<PremiumAdoption> | null>(null)
  const [arePremiumDealersLoaded, setArePremiumDealersLoaded] = useState(false)

  useEffect(() => {
    Api.PremiumAdoption.get()
      .then((res : Array<PremiumAdoption> | null) => {
        setPremiumDealers(res)
      })
      .catch(() => {
        setPremiumDealers(null)
      })
      .finally(() => {
        setArePremiumDealersLoaded(true)
      })
  }, [])

  return { premiumDealers, arePremiumDealersLoaded }
}

export default usePremiumAdoption
